import React, {
	useState, useEffect, useContext, useRef,
} from 'react';
import { useOutletContext } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';
import { isValidEmail } from '../../../helpers/form-validation';
import { CustomerContext } from '../../../contexts/customer-context';

import Button from '../../../component-library/button';
import SpinnerContainer from '../../../component-library/spinner-container';
import FormField from '../../../component-library/form-field';
import FormCheckbox from '../../../component-library/form-checkbox';
import Tile from '../../../component-library/tile';

import RefDataSearchModal from './sub-components-kp/ref-data-search-modal';
import FormItem from './sub-components-kp/form-item';
import BindingTypeFields from './sub-components-kp/binding-type-fields';

const RegisterForAccessFormKpEvent = () => {
	const { data, uiMenuConfig } = useOutletContext();
	const {
		refDatas = [],
	} = useContext(CustomerContext);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [conversationId, setConversationId] = useState('');
	const [formMetaData, setFormMetaData] = useState({});
	const [formData, setFormData] = useState([]);
	const [message, setMessage] = useState('I would like to request provider approval to get API access.');
	const [messageError, setMessageError] = useState('');
	const [disableSubmit, setDisableSubmit] = useState(false);
	const [showSuccess, setShowSuccess] = useState(false);
	const [showRefDataSearchModal, setShowRefDataSearchModal] = useState(false);
	const [channels, setChannels] = useState([]);
	const channelsRef = useRef([]);
	channelsRef.current = channels;
	const [hasOauth, setHasOauth] = useState(false);
	const maxCommentLength = 512;

	const handleChange = (index, value) => {
		const newFormData = [
			...formData,
		];
		newFormData[index].value = value;

		const formField = newFormData[index];

		// When selecting/deselecting subscription make sure
		// associated fields have the correct hidden value
		if (formField.id === 'subscription') {
			const field1 = newFormData.find(item => item.id === 'prodtranssec');
			const field2 = newFormData.find(item => item.id === 'prodpeaktranssec');
			const field3 = newFormData.find(item => item.id === 'prodmaxvolday');
			const field4 = newFormData.find(item => item.id === 'prodtimefram');
			const field5 = newFormData.find(item => item.id === 'prodavemsgsize');
			const field6 = newFormData.find(item => item.id === 'prodmaxmsgsize');
			const field1Index = newFormData.indexOf(field1);
			const field2Index = newFormData.indexOf(field2);
			const field3Index = newFormData.indexOf(field3);
			const field4Index = newFormData.indexOf(field4);
			const field5Index = newFormData.indexOf(field5);
			const field6Index = newFormData.indexOf(field6);

			if (value === 'true') {
				newFormData[field1Index].hidden = false;
				newFormData[field2Index].hidden = false;
				newFormData[field3Index].hidden = false;
				newFormData[field4Index].hidden = false;
				newFormData[field5Index].hidden = false;
				newFormData[field6Index].hidden = false;
			} else {
				newFormData[field1Index].hidden = true;
				newFormData[field2Index].hidden = true;
				newFormData[field3Index].hidden = true;
				newFormData[field4Index].hidden = true;
				newFormData[field5Index].hidden = true;
				newFormData[field6Index].hidden = true;
			}
			newFormData[field1Index].value = '';
			newFormData[field2Index].value = '';
			newFormData[field3Index].value = '';
			newFormData[field4Index].value = '';
			newFormData[field5Index].value = '';
			newFormData[field6Index].value = '';
		}

		// When selecting/deselecting newClientId make sure
		// associated fields have the correct required value
		if (formField.id === 'newClientId') {
			const field1 = newFormData.find(item => item.id === 'clientIdEnvironment');
			const field2 = newFormData.find(item => item.id === 'grantType');
			const field3 = newFormData.find(item => item.id === 'consumerAtlasTechLeadEmail');
			const field1Index = newFormData.indexOf(field1);
			const field2Index = newFormData.indexOf(field2);
			const field3Index = newFormData.indexOf(field3);

			if (value === true) {
				newFormData[field1Index].required = true;
				newFormData[field2Index].required = true;
				newFormData[field3Index].required = true;
			} else {
				newFormData[field1Index].required = false;
				newFormData[field2Index].required = false;
				newFormData[field3Index].required = false;
			}
		}

		setFormData(newFormData);
	};

	const handleMultiSelectChange = (index, value) => {
		const newArray = Array.from(value, newItem => newItem.value);
		const newFormData = [
			...formData,
		];
		newFormData[index].value = newArray;
		setFormData(newFormData);
	};

	const checkAtlasDesignIdStatus = () => {
		// Check required/disabled status of fields depending on state of atlasDesignId
		const newFormData = [
			...formData,
		];

		const atlasDesignId = newFormData.find(item => item.id === 'atlasDesignId');
		const atlasId = newFormData.find(item => item.id === 'atlasId');

		const field1 = newFormData.find(item => item.id === 'applicationType');
		const field2 = newFormData.find(item => item.id === 'applicationCategory');
		const field3 = newFormData.find(item => item.id === 'atlasDesignId');
		const field4 = newFormData.find(item => item.id === 'atlasDesignName');
		const field5 = newFormData.find(item => item.id === 'appComponent');

		const field1Index = newFormData.indexOf(field1);
		const field2Index = newFormData.indexOf(field2);
		const field3Index = newFormData.indexOf(field3);
		const field4Index = newFormData.indexOf(field4);
		const field5Index = newFormData.indexOf(field5);

		if (atlasId?.value.includes('APP')) {
			newFormData[field1Index].value = 'internal';
		} else if (atlasId?.value.includes('PRF')) {
			newFormData[field1Index].value = 'external';
		}

		if (atlasDesignId.value) {
			newFormData[field1Index].required = false;
			newFormData[field2Index].required = false;
			newFormData[field1Index].hidden = true;
			newFormData[field2Index].hidden = true;
			newFormData[field5Index].hidden = true;
			newFormData[field1Index].value = '';
			newFormData[field2Index].value = '';
			newFormData[field5Index].value = '';
			newFormData[field3Index].hidden = false;
			newFormData[field4Index].hidden = false;
		} else {
			newFormData[field1Index].required = true;
			newFormData[field2Index].required = true;
			newFormData[field1Index].hidden = false;
			newFormData[field2Index].hidden = false;
			newFormData[field3Index].hidden = true;
			newFormData[field4Index].hidden = true;
			newFormData[field5Index].hidden = false;
			newFormData[field3Index].value = '';
			newFormData[field4Index].value = '';
		}

		setFormData(newFormData);
	};

	const handleRefDataClick = item => {
		const matchArray = formMetaData?.refDataMatching || [];
		const newFormData = [
			...formData,
		];

		if (matchArray?.length) {
			matchArray.forEach(entry => {
				const formDataItem = formData.find(i => i.id === entry.formFieldId);
				const formDataIndex = formData.indexOf(formDataItem);

				newFormData[formDataIndex].value = item[entry.refDataField];
			});
		}

		setShowRefDataSearchModal(false);
		setFormData(newFormData);
		checkAtlasDesignIdStatus();
	};

	const handleMessageChange = value => {
		setMessage(value);
	};

	const handleChannelChange = (index, value) => {
		const newChannels = [
			...channels,
		];
		newChannels[index].value = value;
		setChannels(newChannels);
	};

	const handleBindingDetailsChange = (channelIndex, value, bindingFieldId) => {
		const newChannels = [
			...channelsRef.current,
		];
		newChannels[channelIndex].bindingDetails.find(item => item.id === bindingFieldId).value = value;
		const currentBindingField = newChannels[channelIndex].bindingDetails.find(
			item => item.id === bindingFieldId,
		);
		if (currentBindingField?.subtype === 'dropdown') {
			const matchingListValue = currentBindingField?.listValues?.find(item => item.value === value);
			const onSelect = matchingListValue?.onSelect;
			const hasOnSelect = (
				onSelect
				&& typeof onSelect === 'object'
				&& !Array.isArray(onSelect)
				&& Object.keys(onSelect).length > 0
			);
			if (hasOnSelect) {
				Object.keys(matchingListValue?.onSelect).forEach(key => {
					const newFieldName = key;
					const newFieldValue = matchingListValue?.onSelect[newFieldName];
					newChannels[channelIndex].bindingDetails.find(
						item => item.name === newFieldName,
					).value = newFieldValue;
				});
			}
		}
		setChannels(newChannels);
	};

	const getConversationId = () => {
		fetchData({
			uri: `/api/web/asks/catitem/${data.id}?pageSize=0`,
			method: 'GET',
		})
			.then(res => {
				const newConversationId = res.body.conversations[0].conversation.key;
				setConversationId(newConversationId);
			});
	};

	const handleSubmit = () => {
		const newItems = [];
		formData.forEach(item => {
			if (item.type !== 'subheading') {
				const newItem = {
					label: item.label,
					value: item.value,
					id: item.id,
				};
				newItems.push(newItem);
			}
		});
		const selectedChannels = channelsRef.current.filter(channel => channel.value === true);
		const newChannels = selectedChannels.map(channel => ({
			name: channel.name,
			id: channel.id,
			value: channel.value,
			bindingDetails: channel.bindingDetails.reduce((acc, item) => {
				acc[item.id] = item.value;
				return acc;
			}, {}),
		}));
		const commentData = {
			message,
			styling: 'request',
			template: 'event',
			templatedData: {
				bindingTypeCode: formMetaData?.bindingTypeCode || '',
				items: newItems,
				channels: newChannels,
			},
		};

		fetchData({
			uri: `/api/web/asks/catitem/${data.id}/conv/${conversationId}`,
			method: 'POST',
			options: {
				body: JSON.stringify(commentData),
			},
		})
			.then(({ ok }) => {
				if (ok) {
					setShowSuccess(true);
					setDisableSubmit(false);
				} else {
					setError('Sorry, your request could not be sent at this time, please try again.');
					setDisableSubmit(false);
				}
			})
			.catch(() => {
				setError('Sorry, your request could not be sent at this time, please try again.');
				setDisableSubmit(false);
			});
	};

	const handleValidation = isDuplicate => {
		let newError = false;
		const newFormData = [];
		if (message === '') {
			newError = true;
			setMessageError('You must add a message.');
		}
		if (message.length > maxCommentLength) {
			newError = true;
			setMessageError(`Message must be less than ${maxCommentLength} characters in length.`);
		}
		formData.forEach(item => {
			if (item.required === true && item.type !== 'email' && item.value?.length === 0) {
				newError = true;
				const newItem = {
					...item,
					error: 'This is a required field.',
				};
				newFormData.push(newItem);
			} else if (item.required === true && item.type === 'email') {
				if (!isValidEmail(item.value)) {
					newError = true;
					const newItem = {
						...item,
						error: 'Must be a valid email address.',
					};
					newFormData.push(newItem);
				} else {
					const newItem = {
						...item,
						error: '',
					};
					newFormData.push(newItem);
				}
			} else {
				const newItem = {
					...item,
					error: '',
				};
				newFormData.push(newItem);
			}
		});

		const newChannels = channelsRef.current.map(channel => ({
			...channel,
			bindingDetails: channel.bindingDetails.map(item => {
				if (channel.value && item.required === true && item.value?.length === 0) {
					newError = true;
					return {
						...item,
						error: 'This is a required field.',
					};
				}
				return {
					...item,
					error: '',
				};
			}),
		}));

		// Validate duplicate design name
		const newAppComponent = newFormData.find(item => item.id === 'appComponent');
		const newAppComponentIndex = newFormData.indexOf(newAppComponent);
		if (isDuplicate) {
			newError = true;
			newFormData[newAppComponentIndex].error = 'This value will result in a duplicate being created, please select a unique value.';
		} else {
			newFormData[newAppComponentIndex].error = '';
		}

		if (newError === true) {
			setFormData(newFormData);
			setChannels(newChannels);
			setDisableSubmit(false);
		} else {
			setFormData(newFormData);
			setChannels(newChannels);
			handleSubmit();
		}
	};

	const checkDuplicateDesign = () => {
		setDisableSubmit(true);

		const newFormData = [
			...formData,
		];

		const atlasDesignId = newFormData.find(item => item.id === 'atlasDesignId');

		// Only check for a duplicate design if no atlasDesignId
		if (atlasDesignId.value) {
			handleValidation(false);
		} else {
			let newDesignName = '';

			const newAtlasName = newFormData.find(item => item.id === 'atlasName').value;
			const newAppComponent = newFormData.find(item => item.id === 'appComponent').value;

			if (newAppComponent) {
				newDesignName = `${newAtlasName} ${newAppComponent}`;
			} else {
				newDesignName = newAtlasName;
			}

			newDesignName = encodeURIComponent(newDesignName);

			fetchData({
				uri: `/api/web/ics/search/appname?text=${newDesignName}`,
				method: 'GET',
			})
				.then(({ ok, body }) => {
					if (ok) {
						if (body.results?.length > 0) {
							handleValidation(true);
						} else {
							handleValidation(false);
						}
					} else {
						handleValidation(false);
					}
				})
				.catch(() => {
					handleValidation(false);
				});
		}
	};

	const getBindingTypeId = value => {
		if (value.includes('.')) {
			const parts = value.split('.');
			return parts[parts.length - 1];
		}
		return value;
	};

	const getBindingTypeValue = type => {
		if (type === 'boolean') {
			return false;
		}
		return '';
	};

	const getBindingTypeData = metaData => {
		const bindingTypeCode = metaData?.bindingTypeCode;
		const channelOpBindings = refDatas.find(item => item.code === 'ChannelOpBinding');
		const selectedBindingType = channelOpBindings.refdatalist.find(
			item => item.code === bindingTypeCode,
		);
		const visualStyle = selectedBindingType?.visualStyle
			? JSON.parse(selectedBindingType.visualStyle)
			: [];
		const newBindingTypeData = visualStyle.map(item => ({
			name: item.name,
			description: item.description,
			type: item.type,
			id: getBindingTypeId(item.value),
			value: getBindingTypeValue(item.type),
			error: '',
			path: item.value,
			required: item.required,
			subtype: item.subtype || null,
			listValues: item.listValues || null,
		}));
		const newChannels = [];
		channelsRef.current.forEach(channel => {
			const newChannel = {
				...channel,
				bindingDetails: newBindingTypeData.map(item => ({ ...item })),
			};
			newChannels.push(newChannel);
		});
		setChannels(newChannels);
	};

	const getData = () => {
		fetchData({
			uri: '/api/web/asks/template/event',
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const newFormData = body.items;
					const newFormMetaData = body?.metadata || {};
					setFormMetaData(newFormMetaData);
					setFormData(newFormData);
					setLoading(false);
					getBindingTypeData(newFormMetaData);
				} else {
					setLoading(false);
				}
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const getOauthData = () => {
		fetchData({
			uri: `/api/web/ics/search/secpolicy?ids=${data.id}`,
			method: 'GET',
		})
			.then(({ ok, body }) => {
				if (ok) {
					const policies = body?.results[0]?.policies || [];
					if (policies.length) {
						setHasOauth(true);
					}
				}
			});
	};

	const getChannelsData = () => {
		const newChannels = [];
		if (data?.channels?.length > 0) {
			data.channels.map(channel => {
				const newChannel = {
					id: channel.id,
					name: channel.name,
					description: channel.description,
					value: false,
				};
				newChannels.push(newChannel);
				return newChannel;
			});
		}
		setChannels(newChannels);
	};

	useEffect(() => {
		getData();
		getChannelsData();
		getOauthData();
		getConversationId();
	}, []);

	return (
		<>
			<h3>{uiMenuConfig?.registerForAccess?.label || 'Subscribe'}</h3>
			{loading && (
				<SpinnerContainer />
			)}
			{showSuccess && (
				<Tile className="margin-bottom-24">
					<p><strong>Your access request has been submitted.</strong></p>
					<p>
						Thank you for submitting your request, the provider will be in touch shortly.
						You can find updates to your request in the &rsquo;Contact Provider&rsquo; section.
					</p>
				</Tile>
			)}
			{(!loading && !showSuccess) && (
				<Tile className="margin-bottom-24">
					<p>Request provider approval to get API access.</p>
					<div className="border-bottom">
						<FormField
							label="Message"
							type="text"
							action={e => { handleMessageChange(e.target.value); }}
							id="message"
							name="message"
							value={message}
							required
							error={messageError}
							fullWidth
						/>
					</div>
					{formData?.length ? (
						<>
							<div className="get-api-access__form-row-2-col">
								{formData.map((field, index) => (
									<FormItem
										// eslint-disable-next-line react/no-array-index-key
										key={index}
										field={field}
										index={index}
										hasOauth={hasOauth}
										handleChange={(idx, value) => handleChange(idx, value)}
										handleMultiSelectChange={
											(idx, options) => handleMultiSelectChange(idx, options)
										}
										setShowRefDataSearchModal={() => setShowRefDataSearchModal(true)}
									/>
								))}
							</div>
							{channels.length > 0 && (
								<div className="get-api-access__form-row-2-col">
									<div className="get-api-access__form-row-span">
										<div className="border-top padding-top-16">
											<h3>Select a Channel</h3>
											<p>Select the channel(s) you would like to subscribe to.</p>
										</div>
										<div className="border-top margin-bottom-16">
											{channels.map((channel, index) => (
												<div className="padding-top-16 border-bottom padding-bottom-16">
													<div className="flex-row justify-content-start align-items-start">
														<div>
															<FormCheckbox
																// eslint-disable-next-line react/no-array-index-key
																key={index}
																action={e => { handleChannelChange(index, e.target.checked); }}
																id={`channel-id-${channel.id}`}
																value={channel.value}
															/>
														</div>
														<div>
															<h5>{channel.name}</h5>
															<p className="margin-bottom-none">{channel.description}</p>
														</div>
													</div>
													{channel.value && (
														<div className="margin-top-16">
															<h4>Binding Details</h4>
															<BindingTypeFields
																channelIndex={index}
																bindingTypeData={channel.bindingDetails}
																handleBindingDetailsChange={
																	(
																		channelIndex,
																		value,
																		bindingFieldId,
																	) => handleBindingDetailsChange(
																		channelIndex,
																		value,
																		bindingFieldId,
																	)
																}
															/>
														</div>
													)}
												</div>
											))}
										</div>
									</div>
								</div>
							)}
							{error && (
								<p className="font-color-theme-danger">{error}</p>
							)}
							<div className="text-right">
								<Button
									type="primary"
									label="Submit"
									onClick={() => checkDuplicateDesign()}
									isDisabled={disableSubmit}
								/>
							</div>
						</>
					) : (
						<p className="grey-text margin-top-16">
							No form fields have been configured.
						</p>
					)}
				</Tile>
			)}
			{showRefDataSearchModal && (
				<RefDataSearchModal
					type="event"
					handleCloseModal={() => setShowRefDataSearchModal(false)}
					handleApplyData={item => handleRefDataClick(item)}
				/>
			)}
		</>
	);
};

export default RegisterForAccessFormKpEvent;
